export const ReportTypes = Object.freeze(
{
    CHART: "Chart",
    DATASET_DOWNLOAD: "Dataset download",
    Default: "NA"
})